import { __assign, __makeTemplateObject, __rest } from "tslib";
import React, { forwardRef, useMemo, useRef } from 'react';
import clsx from 'clsx';
import MuiSwitch from '@material-ui/core/Switch';
import { combineClasses, omit, useThemeProps, useForkRef, } from '../../../foundation';
import styled from '../../../foundation/styled-components';
import { RcFormControlLabel } from '../FormControlLabel';
import { SwitchStyle } from './styles';
import { RcSwitchClasses } from './utils';
var _RcSwitch = forwardRef(function (inProps, ref) {
    var props = useThemeProps({ props: inProps, name: 'RcSwitch' });
    var label = props.label, _a = props.formControlLabelProps, formControlLabelProps = _a === void 0 ? {} : _a, focusVisibleClassNameProp = props.focusVisibleClassName, classesProp = props.classes, color = props.color, trackColor = props.trackColor, _b = props.inputRef, inputRefProp = _b === void 0 ? null : _b, onFocus = props.onFocus, onBlur = props.onBlur, rest = __rest(props, ["label", "formControlLabelProps", "focusVisibleClassName", "classes", "color", "trackColor", "inputRef", "onFocus", "onBlur"]);
    var classes = useMemo(function () { return combineClasses(omit(RcSwitchClasses, ['focusVisible']), classesProp); }, [classesProp]);
    var focusVisibleClassName = useMemo(function () { return clsx(RcSwitchClasses.focusVisible, focusVisibleClassNameProp); }, [focusVisibleClassNameProp]);
    var inputRef = useRef(null);
    var handleInputRef = useForkRef(inputRef, inputRefProp);
    var Switch = (React.createElement(MuiSwitch, __assign({ ref: ref, inputRef: handleInputRef, focusVisibleClassName: focusVisibleClassName, classes: classes }, rest, { color: "default", size: "medium", disableRipple: true, disableTouchRipple: true, onFocus: function (e) {
            var _a;
            if ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.matches('[data-focus-visible-added]')) {
                e.currentTarget.parentElement.setAttribute('data-focus-visible-within', '');
            }
            onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
        }, onBlur: function (e) {
            e.currentTarget.parentElement.removeAttribute('data-focus-visible-within');
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
        } })));
    if (label) {
        return (React.createElement(RcFormControlLabel, __assign({}, formControlLabelProps, { label: label, control: Switch })));
    }
    return Switch;
});
var RcSwitch = styled(_RcSwitch)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), SwitchStyle);
RcSwitch.defaultProps = {
    color: 'interactive.f01',
};
RcSwitch.displayName = 'RcSwitch';
export { RcSwitch };
var templateObject_1;
